import { Component, Input } from '@angular/core';
import { formatDate } from '@angular/common';
import { Account } from '@services/accounts.service';
import { getDaysUntilExpiry, isExpired } from '@functions/functions';

/** AccountExpiryComponent */
@Component({
	selector: 'app-account-expiry',
	templateUrl: './account-expiry.component.html',
	styleUrls: ['./account-expiry.component.scss'],
})
export class AccountExpiryComponent {

	/** Selected Account */
	@Input() selectedAccount: Account;

	/** Show as a banner */
	@Input() Banner: boolean = false;

	/** Show as a Pill style */
	@Input() pill: boolean = false;


	/** 
	 * isExpired 
	 * Imported from @functions/functions to use in HTML
	 */
	public isExpired = isExpired;

	/**
	 * Generates a trial message based on the expiry date
	 * @returns 
	 */
	getTrialMessage(expiryMSG: string, expiry: Date | string | number): string {

		if (this.selectedAccount.Expiry == 0) {
			return expiryMSG;
		}

		const formattedDate = formatDate(expiry, 'dd-MMM-yyyy', 'en-GB');
		// If already expired or within current month → check days
		const diffDays = getDaysUntilExpiry(expiry);

		switch (diffDays) {
			case 0:
				expiryMSG += ` expiring today (${formattedDate})`;
				break;
			case 1:
				expiryMSG += ` expiring tomorrow (${formattedDate})`;
				break;
			default:
				if (diffDays > 1 && diffDays <= 30) {
					expiryMSG += ` expiring soon in ${diffDays} day${diffDays > 1 ? "s" : ""} (${formattedDate})`;
				} else if (diffDays < 0) {
					expiryMSG += ` expired on ${formattedDate}`;
				}
		}

		return expiryMSG;
	}

}
